import { defaultStatus } from '../defaultState/defaultState'
import {
  ADD_DOCTOR_FAILURE,
  ADD_DOCTOR_REQUEST,
  ADD_DOCTOR_SUCCESS,
  DELETE_DOCTOR_FAILURE,
  DELETE_DOCTOR_REQUEST,
  DELETE_DOCTOR_SUCCESS,
  FETCH_DOCTOR_FAILURE,
  FETCH_DOCTOR_REQUEST,
  FETCH_DOCTOR_SUCCESS,
  FETCH_LIST_DOCTORS_FAILURE,
  FETCH_LIST_DOCTORS_REQUEST,
  FETCH_LIST_DOCTORS_SUCCESS,
  HISTORY_DOCTORS_FAILURE,
  HISTORY_DOCTORS_REQUEST,
  HISTORY_DOCTORS_SUCCESS,
  RESET_CURRENT_DOCTOR,
  UPDATE_DOCTOR_FAILURE,
  UPDATE_DOCTOR_REQUEST,
  UPDATE_DOCTOR_SUCCESS
} from './doctorType'

const initialState = {

  addDoctor: { ...defaultStatus },
  deleteDoctor: { ...defaultStatus },
  fetchListDoctors: { ...defaultStatus },
  fetchDoctor: { ...defaultStatus },
  updateDoctor: { ...defaultStatus },
  historyDoctor: { ...defaultStatus }
}

const doctorReducer = (state = initialState, action) => {
  const { type, payload } = action
  switch (type) {
    
    case FETCH_LIST_DOCTORS_REQUEST:
      return {
        ...state,
        fetchListDoctors: {
          ...state.fetchListDoctors,
          inProgress: true,
          error: null
        }
      }
    case FETCH_LIST_DOCTORS_SUCCESS:
      return {
        ...state,
        fetchListDoctors: {
          ...state.fetchListDoctors,
          inProgress: false,
          success: true,
          data: payload?.doctors?.data
        },
      }
    case FETCH_LIST_DOCTORS_FAILURE:
      return {
        ...state,
        fetchListDoctors: {
          ...state.fetchListDoctors,
          inProgress: false,
          error: true,
          errorMessage: payload.error
        }
      }
      case HISTORY_DOCTORS_REQUEST:
        return {
          ...state,
          historyDoctor: {
            ...state.fetchListDoctors,
            inProgress: true,
            error: null
          }
        }
      case HISTORY_DOCTORS_SUCCESS:
        return {
          ...state,
          historyDoctor: {
            ...state.fetchListDoctors,
            inProgress: false,
            success: true,
            data: payload?.doctors?.data
          },
        }
      case HISTORY_DOCTORS_FAILURE:
        return {
          ...state,
          historyDoctor: {
            ...state.fetchListDoctors,
            inProgress: false,
            error: true,
            errorMessage: payload.error
          }
        }
    
    case FETCH_DOCTOR_REQUEST:
      return {
        ...state,
        fetchDoctor: { ...state.fetchDoctor, inProgress: true, error: null }
      }
    case FETCH_DOCTOR_SUCCESS:
      return {
        ...state,
        fetchDoctor: {
          ...state.fetchDoctor,
          inProgress: false,
          success: true,
          data: payload?.doctor?.data
         
        },
  
      }
    case FETCH_DOCTOR_FAILURE:
      return {
        ...state,
        fetchDoctor: {
          ...state.fetchDoctor,
          inProgress: false,
          error: true,
          errorMessage: payload.error
        }
      }

      case ADD_DOCTOR_REQUEST:
        return {
          ...state,
          addDoctor: { 
            ...state.addDoctor, 
            inProgress: true, 
            success: false,
            error: null,
            errorMessage: null
          }
        };
      case ADD_DOCTOR_SUCCESS:
        return {
          ...state,
          addDoctor: {
            ...state.addDoctor,
            inProgress: false,
            error:false,
            success: true,
            data: payload?.doctor
          },
        };
      case ADD_DOCTOR_FAILURE:
        return {
          ...state,
          addDoctor: {
            ...state.addDoctor,
            inProgress: false,
            success: false,
            error: true,
            errorMessage: payload?.errorMessage || null,
            ...payload
          }
        };

    // Edit doctor
    case UPDATE_DOCTOR_REQUEST:
      return {
        ...state,
        updateDoctor: { ...state.updateDoctor, inProgress: true, error: null }
      }
    case UPDATE_DOCTOR_SUCCESS: {
      return {
        ...state,
        updateDoctor: {
            ...state.addDoctor,
            inProgress: false,
            success: true,
            error:false,
            data: payload?.doctor
          },
      }
    }
    case UPDATE_DOCTOR_FAILURE:
      return {
        ...state,
        updateDoctor: {
            ...state.addDoctor,
            inProgress: false,
            success: false,
            error: true,
            errorMessage: payload?.errorMessage || null,
            ...payload
          }
      }

    // Delete doctor
    case DELETE_DOCTOR_REQUEST:
      return {
        ...state,
        deleteDoctor: { ...state.deleteDoctor, inProgress: true, error: null }
      }
    case DELETE_DOCTOR_SUCCESS:
      return {
        ...state,
        deleteDoctor: {
          ...state.deleteDoctor,
          inProgress: false,
          success: true
        },
        doctors: {
          ...state.doctors,
          data: state.doctors.data.filter(
            doctor => doctor.id !== payload.doctorId
          )
        },
        currentDoctor:
          state.currentDoctor.data?.id === payload.doctorId
            ? { ...defaultStatus, data: null }
            : state.currentDoctor
      }
    case DELETE_DOCTOR_FAILURE:
      return {
        ...state,
        deleteDoctor: {
          ...state.deleteDoctor,
          inProgress: false,
          error: true,
          errorMessage: payload.error
        }
      }

    // Reset current doctor
    case RESET_CURRENT_DOCTOR:
      return { ...defaultStatus }

    default:
      return state
  }
}

export default doctorReducer